import { call, all } from 'redux-saga/effects';
import {watchGetDataLogin, watchSetDataLogin,watchLogin} from "./loginSaga";
//IndexImportHygen

export default function* rootLoginSaga() {
  yield all([
    call(watchGetDataLogin),
    call(watchSetDataLogin),
    call(watchLogin),
    //IndexUsingHygen
    ])
}